import { render, staticRenderFns } from "./userExplantionComponent.vue?vue&type=template&id=7378f36f&scoped=true"
import script from "./userExplantionComponent.vue?vue&type=script&lang=js"
export * from "./userExplantionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7378f36f",
  null
  
)

export default component.exports